import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/hotelCategoryDictionaryInfo', request)
}

export {get}
